module.exports = __webpack_public_path__ + "static/media/optAdvanced.f7180d02.jpg";